module.exports = __webpack_public_path__ + "media/scholarship_winners/katherine-h-7afa0534.png";